export default {
  defaultAuth: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000157","默认权限") /* "默认权限" */
};
